'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M6.325 21.932a.423.423 0 0 1-.64-.448l1.445-6.607a.42.42 0 0 0-.128-.404l-4.864-4.451a.424.424 0 0 1 .247-.735l6.381-.581a.42.42 0 0 0 .354-.263l2.488-6.178a.422.422 0 0 1 .784 0l2.488 6.178c.06.147.196.249.354.263l6.38.58a.424.424 0 0 1 .248.736l-4.864 4.45a.43.43 0 0 0-.128.405l1.446 6.607a.423.423 0 0 1-.64.448l-5.449-3.48a.42.42 0 0 0-.454 0z" /></svg>;
const IconStarFilled = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconStarFilled;